import React, { useState, useEffect } from "react";
import { Card, Divider, Pagination } from "@mui/material";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import axios from "axios";
import CageData from "layouts/billing/components/CageActivitiesData";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import { baseurl } from "domain";

function RecentActivitiesPage() {
  const [userLogsData, setUserLogsData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const logsPerPage = 5;

  useEffect(() => {
    const fetchUserLogsData = async () => {
      try {
        const response = await axios.get(`https://${baseurl}/getAllLogs`);
        setUserLogsData(response.data.logs);
      } catch (error) {
        console.error("Error fetching user logs:", error);
      }
    };

    fetchUserLogsData();
  }, []);

  const indexOfLastLog = currentPage * logsPerPage;
  const indexOfFirstLog = indexOfLastLog - logsPerPage;
  const currentLogs = userLogsData.slice(indexOfFirstLog, indexOfLastLog);

  const handlePageChange = (event, value) => {
    setCurrentPage(value);
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox py={3}>
        <Card sx={{ position: "relative", mx: 3, py: 2, px: 2 }}>
          <MDBox pt={3} px={2}>
            <MDTypography variant="h4" fontWeight="medium">
              Recent Activities
            </MDTypography>
          </MDBox>
          <MDBox pt={1} pb={2} px={2}>
            <MDBox component="ul" display="flex" flexDirection="column" p={0} m={0}>
              {currentLogs.map((log, index) => (
                <CageData key={index} name={log.msg} uname={log.timestamp} />
              ))}
            </MDBox>
            <MDBox display="flex" justifyContent="center" mt={2}>
              <Pagination
                count={Math.ceil(userLogsData.length / logsPerPage)}
                page={currentPage}
                onChange={handlePageChange}
                color="primary"
              />
            </MDBox>
          </MDBox>
        </Card>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}

export default RecentActivitiesPage;